export const COUNTRIES_RAW: any = [
    {
      "nameES": "AFGANISTÁN",
      "nameEN": "Afghanistan",
      "iso2": "AF",
      "iso3": "AFG",
      "phoneCode": "93"
    },
    {
      "nameES": "ALBANIA",
      "nameEN": "Albania",
      "iso2": "AL",
      "iso3": "ALB",
      "phoneCode": "355"
    },
    {
      "nameES": "ALEMANIA",
      "nameEN": "Germany",
      "iso2": "DE",
      "iso3": "DEU",
      "phoneCode": "49"
    },
    {
      "nameES": "ANDORRA",
      "nameEN": "Andorra",
      "iso2": "AD",
      "iso3": "AND",
      "phoneCode": "376"
    },
    {
      "nameES": "ANGOLA",
      "nameEN": "Angola",
      "iso2": "AO",
      "iso3": "AGO",
      "phoneCode": "244"
    },
    {
      "nameES": "ANGUILA",
      "nameEN": "Anguilla",
      "iso2": "AI",
      "iso3": "AIA",
      "phoneCode": "1 264"
    },
    {
      "nameES": "ANTÁRTIDA",
      "nameEN": "Antarctica",
      "iso2": "AQ",
      "iso3": "ATA",
      "phoneCode": "672"
    },
    {
      "nameES": "ANTIGUA Y BARBUDA",
      "nameEN": "Antigua and Barbuda",
      "iso2": "AG",
      "iso3": "ATG",
      "phoneCode": "1 268"
    },
    {
      "nameES": "ARABIA SAUDITA",
      "nameEN": "Saudi Arabia",
      "iso2": "SA",
      "iso3": "SAU",
      "phoneCode": "966"
    },
    {
      "nameES": "ARGELIA",
      "nameEN": "Algeria",
      "iso2": "DZ",
      "iso3": "DZA",
      "phoneCode": "213"
    },
    {
      "nameES": "ARGENTINA",
      "nameEN": "Argentina",
      "iso2": "AR",
      "iso3": "ARG",
      "phoneCode": "54"
    },
    {
      "nameES": "ARMENIA",
      "nameEN": "Armenia",
      "iso2": "AM",
      "iso3": "ARM",
      "phoneCode": "374"
    },
    {
      "nameES": "ARUBA",
      "nameEN": "Aruba",
      "iso2": "AW",
      "iso3": "ABW",
      "phoneCode": "297"
    },
    {
      "nameES": "AUSTRALIA",
      "nameEN": "Australia",
      "iso2": "AU",
      "iso3": "AUS",
      "phoneCode": "61"
    },
    {
      "nameES": "AUSTRIA",
      "nameEN": "Austria",
      "iso2": "AT",
      "iso3": "AUT",
      "phoneCode": "43"
    },
    {
      "nameES": "AZERBAIYÁN",
      "nameEN": "Azerbaijan",
      "iso2": "AZ",
      "iso3": "AZE",
      "phoneCode": "994"
    },
    {
      "nameES": "BÉLGICA",
      "nameEN": "Belgium",
      "iso2": "BE",
      "iso3": "BEL",
      "phoneCode": "32"
    },
    {
      "nameES": "BAHAMAS",
      "nameEN": "Bahamas",
      "iso2": "BS",
      "iso3": "BHS",
      "phoneCode": "1 242"
    },
    {
      "nameES": "BAHREIN",
      "nameEN": "Bahrain",
      "iso2": "BH",
      "iso3": "BHR",
      "phoneCode": "973"
    },
    {
      "nameES": "BANGLADESH",
      "nameEN": "Bangladesh",
      "iso2": "BD",
      "iso3": "BGD",
      "phoneCode": "880"
    },
    {
      "nameES": "BARBADOS",
      "nameEN": "Barbados",
      "iso2": "BB",
      "iso3": "BRB",
      "phoneCode": "1 246"
    },
    {
      "nameES": "BELICE",
      "nameEN": "Belize",
      "iso2": "BZ",
      "iso3": "BLZ",
      "phoneCode": "501"
    },
    {
      "nameES": "BENÍN",
      "nameEN": "Benin",
      "iso2": "BJ",
      "iso3": "BEN",
      "phoneCode": "229"
    },
    {
      "nameES": "BHUTÁN",
      "nameEN": "Bhutan",
      "iso2": "BT",
      "iso3": "BTN",
      "phoneCode": "975"
    },
    {
      "nameES": "BIELORRUSIA",
      "nameEN": "Belarus",
      "iso2": "BY",
      "iso3": "BLR",
      "phoneCode": "375"
    },
    {
      "nameES": "BIRMANIA",
      "nameEN": "Myanmar",
      "iso2": "MM",
      "iso3": "MMR",
      "phoneCode": "95"
    },
    {
      "nameES": "BOLIVIA",
      "nameEN": "Bolivia",
      "iso2": "BO",
      "iso3": "BOL",
      "phoneCode": "591"
    },
    {
      "nameES": "BOSNIA Y HERZEGOVINA",
      "nameEN": "Bosnia and Herzegovina",
      "iso2": "BA",
      "iso3": "BIH",
      "phoneCode": "387"
    },
    {
      "nameES": "BOTSUANA",
      "nameEN": "Botswana",
      "iso2": "BW",
      "iso3": "BWA",
      "phoneCode": "267"
    },
    {
      "nameES": "BRASIL",
      "nameEN": "Brazil",
      "iso2": "BR",
      "iso3": "BRA",
      "phoneCode": "55"
    },
    {
      "nameES": "BRUNÉI",
      "nameEN": "Brunei",
      "iso2": "BN",
      "iso3": "BRN",
      "phoneCode": "673"
    },
    {
      "nameES": "BULGARIA",
      "nameEN": "Bulgaria",
      "iso2": "BG",
      "iso3": "BGR",
      "phoneCode": "359"
    },
    {
      "nameES": "BURKINA FASO",
      "nameEN": "Burkina Faso",
      "iso2": "BF",
      "iso3": "BFA",
      "phoneCode": "226"
    },
    {
      "nameES": "BURUNDI",
      "nameEN": "Burundi",
      "iso2": "BI",
      "iso3": "BDI",
      "phoneCode": "257"
    },
    {
      "nameES": "CABO VERDE",
      "nameEN": "Cape Verde",
      "iso2": "CV",
      "iso3": "CPV",
      "phoneCode": "238"
    },
    {
      "nameES": "CAMBOYA",
      "nameEN": "Cambodia",
      "iso2": "KH",
      "iso3": "KHM",
      "phoneCode": "855"
    },
    {
      "nameES": "CAMERÚN",
      "nameEN": "Cameroon",
      "iso2": "CM",
      "iso3": "CMR",
      "phoneCode": "237"
    },
    {
      "nameES": "CANADÁ",
      "nameEN": "Canada",
      "iso2": "CA",
      "iso3": "CAN",
      "phoneCode": "1"
    },
    {
      "nameES": "CHAD",
      "nameEN": "Chad",
      "iso2": "TD",
      "iso3": "TCD",
      "phoneCode": "235"
    },
    {
      "nameES": "CHILE",
      "nameEN": "Chile",
      "iso2": "CL",
      "iso3": "CHL",
      "phoneCode": "56"
    },
    {
      "nameES": "CHINA",
      "nameEN": "China",
      "iso2": "CN",
      "iso3": "CHN",
      "phoneCode": "86"
    },
    {
      "nameES": "CHIPRE",
      "nameEN": "Cyprus",
      "iso2": "CY",
      "iso3": "CYP",
      "phoneCode": "357"
    },
    {
      "nameES": "CIUDAD DEL VATICANO",
      "nameEN": "Vatican City State",
      "iso2": "VA",
      "iso3": "VAT",
      "phoneCode": "39"
    },
    {
      "nameES": "COLOMBIA",
      "nameEN": "Colombia",
      "iso2": "CO",
      "iso3": "COL",
      "phoneCode": "57"
    },
    {
      "nameES": "COMORAS",
      "nameEN": "Comoros",
      "iso2": "KM",
      "iso3": "COM",
      "phoneCode": "269"
    },
    {
      "nameES": "REPÚBLICA DEL CONGO",
      "nameEN": "Republic of the Congo",
      "iso2": "CG",
      "iso3": "COG",
      "phoneCode": "242"
    },
    {
      "nameES": "REPÚBLICA DEMOCRÁTICA DEL CONGO",
      "nameEN": "Democratic Republic of the Congo",
      "iso2": "CD",
      "iso3": "COD",
      "phoneCode": "243"
    },
    {
      "nameES": "COREA DEL NORTE",
      "nameEN": "North Korea",
      "iso2": "KP",
      "iso3": "PRK",
      "phoneCode": "850"
    },
    {
      "nameES": "COREA DEL SUR",
      "nameEN": "South Korea",
      "iso2": "KR",
      "iso3": "KOR",
      "phoneCode": "82"
    },
    {
      "nameES": "COSTA DE MARFIL",
      "nameEN": "Ivory Coast",
      "iso2": "CI",
      "iso3": "CIV",
      "phoneCode": "225"
    },
    {
      "nameES": "COSTA RICA",
      "nameEN": "Costa Rica",
      "iso2": "CR",
      "iso3": "CRI",
      "phoneCode": "506"
    },
    {
      "nameES": "CROACIA",
      "nameEN": "Croatia",
      "iso2": "HR",
      "iso3": "HRV",
      "phoneCode": "385"
    },
    {
      "nameES": "CUBA",
      "nameEN": "Cuba",
      "iso2": "CU",
      "iso3": "CUB",
      "phoneCode": "53"
    },
    {
      "nameES": "CURAZAO",
      "nameEN": "Curaçao",
      "iso2": "CW",
      "iso3": "CWU",
      "phoneCode": "5999"
    },
    {
      "nameES": "DINAMARCA",
      "nameEN": "Denmark",
      "iso2": "DK",
      "iso3": "DNK",
      "phoneCode": "45"
    },
    {
      "nameES": "DOMINICA",
      "nameEN": "Dominica",
      "iso2": "DM",
      "iso3": "DMA",
      "phoneCode": "1 767"
    },
    {
      "nameES": "ECUADOR",
      "nameEN": "Ecuador",
      "iso2": "EC",
      "iso3": "ECU",
      "phoneCode": "593"
    },
    {
      "nameES": "EGIPTO",
      "nameEN": "Egypt",
      "iso2": "EG",
      "iso3": "EGY",
      "phoneCode": "20"
    },
    {
      "nameES": "EL SALVADOR",
      "nameEN": "El Salvador",
      "iso2": "SV",
      "iso3": "SLV",
      "phoneCode": "503"
    },
    {
      "nameES": "EMIRATOS ÁRABES UNIDOS",
      "nameEN": "United Arab Emirates",
      "iso2": "AE",
      "iso3": "ARE",
      "phoneCode": "971"
    },
    {
      "nameES": "ERITREA",
      "nameEN": "Eritrea",
      "iso2": "ER",
      "iso3": "ERI",
      "phoneCode": "291"
    },
    {
      "nameES": "ESLOVAQUIA",
      "nameEN": "Slovakia",
      "iso2": "SK",
      "iso3": "SVK",
      "phoneCode": "421"
    },
    {
      "nameES": "ESLOVENIA",
      "nameEN": "Slovenia",
      "iso2": "SI",
      "iso3": "SVN",
      "phoneCode": "386"
    },
    {
      "nameES": "ESPAÑA",
      "nameEN": "Spain",
      "iso2": "ES",
      "iso3": "ESP",
      "phoneCode": "34"
    },
    {
      "nameES": "ESTADOS UNIDOS DE AMÉRICA",
      "nameEN": "United States of America",
      "iso2": "US",
      "iso3": "USA",
      "phoneCode": "1"
    },
    {
      "nameES": "ESTONIA",
      "nameEN": "Estonia",
      "iso2": "EE",
      "iso3": "EST",
      "phoneCode": "372"
    },
    {
      "nameES": "ETIOPÍA",
      "nameEN": "Ethiopia",
      "iso2": "ET",
      "iso3": "ETH",
      "phoneCode": "251"
    },
    {
      "nameES": "FILIPINAS",
      "nameEN": "Philippines",
      "iso2": "PH",
      "iso3": "PHL",
      "phoneCode": "63"
    },
    {
      "nameES": "FINLANDIA",
      "nameEN": "Finland",
      "iso2": "FI",
      "iso3": "FIN",
      "phoneCode": "358"
    },
    {
      "nameES": "FIYI",
      "nameEN": "Fiji",
      "iso2": "FJ",
      "iso3": "FJI",
      "phoneCode": "679"
    },
    {
      "nameES": "FRANCIA",
      "nameEN": "France",
      "iso2": "FR",
      "iso3": "FRA",
      "phoneCode": "33"
    },
    {
      "nameES": "GABÓN",
      "nameEN": "Gabon",
      "iso2": "GA",
      "iso3": "GAB",
      "phoneCode": "241"
    },
    {
      "nameES": "GAMBIA",
      "nameEN": "Gambia",
      "iso2": "GM",
      "iso3": "GMB",
      "phoneCode": "220"
    },
    {
      "nameES": "GEORGIA",
      "nameEN": "Georgia",
      "iso2": "GE",
      "iso3": "GEO",
      "phoneCode": "995"
    },
    {
      "nameES": "GHANA",
      "nameEN": "Ghana",
      "iso2": "GH",
      "iso3": "GHA",
      "phoneCode": "233"
    },
    {
      "nameES": "GIBRALTAR",
      "nameEN": "Gibraltar",
      "iso2": "GI",
      "iso3": "GIB",
      "phoneCode": "350"
    },
    {
      "nameES": "GRANADA",
      "nameEN": "Grenada",
      "iso2": "GD",
      "iso3": "GRD",
      "phoneCode": "1 473"
    },
    {
      "nameES": "GRECIA",
      "nameEN": "Greece",
      "iso2": "GR",
      "iso3": "GRC",
      "phoneCode": "30"
    },
    {
      "nameES": "GROENLANDIA",
      "nameEN": "Greenland",
      "iso2": "GL",
      "iso3": "GRL",
      "phoneCode": "299"
    },
    {
      "nameES": "GUADALUPE",
      "nameEN": "Guadeloupe",
      "iso2": "GP",
      "iso3": "GLP",
      "phoneCode": "590"
    },
    {
      "nameES": "GUAM",
      "nameEN": "Guam",
      "iso2": "GU",
      "iso3": "GUM",
      "phoneCode": "1 671"
    },
    {
      "nameES": "GUATEMALA",
      "nameEN": "Guatemala",
      "iso2": "GT",
      "iso3": "GTM",
      "phoneCode": "502"
    },
    {
      "nameES": "GUAYANA FRANCESA",
      "nameEN": "French Guiana",
      "iso2": "GF",
      "iso3": "GUF",
      "phoneCode": "594"
    },
    {
      "nameES": "GUERNSEY",
      "nameEN": "Guernsey",
      "iso2": "GG",
      "iso3": "GGY",
      "phoneCode": "44"
    },
    {
      "nameES": "GUINEA",
      "nameEN": "Guinea",
      "iso2": "GN",
      "iso3": "GIN",
      "phoneCode": "224"
    },
    {
      "nameES": "GUINEA ECUATORIAL",
      "nameEN": "Equatorial Guinea",
      "iso2": "GQ",
      "iso3": "GNQ",
      "phoneCode": "240"
    },
    {
      "nameES": "GUINEA-BISSAU",
      "nameEN": "Guinea-Bissau",
      "iso2": "GW",
      "iso3": "GNB",
      "phoneCode": "245"
    },
    {
      "nameES": "GUYANA",
      "nameEN": "Guyana",
      "iso2": "GY",
      "iso3": "GUY",
      "phoneCode": "592"
    },
    {
      "nameES": "HAITÍ",
      "nameEN": "Haiti",
      "iso2": "HT",
      "iso3": "HTI",
      "phoneCode": "509"
    },
    {
      "nameES": "HONDURAS",
      "nameEN": "Honduras",
      "iso2": "HN",
      "iso3": "HND",
      "phoneCode": "504"
    },
    {
      "nameES": "HONG KONG",
      "nameEN": "Hong Kong",
      "iso2": "HK",
      "iso3": "HKG",
      "phoneCode": "852"
    },
    {
      "nameES": "HUNGRÍA",
      "nameEN": "Hungary",
      "iso2": "HU",
      "iso3": "HUN",
      "phoneCode": "36"
    },
    {
      "nameES": "INDIA",
      "nameEN": "India",
      "iso2": "IN",
      "iso3": "IND",
      "phoneCode": "91"
    },
    {
      "nameES": "INDONESIA",
      "nameEN": "Indonesia",
      "iso2": "ID",
      "iso3": "IDN",
      "phoneCode": "62"
    },
    {
      "nameES": "IRÁN",
      "nameEN": "Iran",
      "iso2": "IR",
      "iso3": "IRN",
      "phoneCode": "98"
    },
    {
      "nameES": "IRAK",
      "nameEN": "Iraq",
      "iso2": "IQ",
      "iso3": "IRQ",
      "phoneCode": "964"
    },
    {
      "nameES": "IRLANDA",
      "nameEN": "Ireland",
      "iso2": "IE",
      "iso3": "IRL",
      "phoneCode": "353"
    },
    {
      "nameES": "ISLA BOUVET",
      "nameEN": "Bouvet Island",
      "iso2": "BV",
      "iso3": "BVT",
      "phoneCode": ""
    },
    {
      "nameES": "ISLA DE MAN",
      "nameEN": "Isle of Man",
      "iso2": "IM",
      "iso3": "IMN",
      "phoneCode": "44"
    },
    {
      "nameES": "ISLA DE NAVIDAD",
      "nameEN": "Christmas Island",
      "iso2": "CX",
      "iso3": "CXR",
      "phoneCode": "61"
    },
    {
      "nameES": "ISLA NORFOLK",
      "nameEN": "Norfolk Island",
      "iso2": "NF",
      "iso3": "NFK",
      "phoneCode": "672"
    },
    {
      "nameES": "ISLANDIA",
      "nameEN": "Iceland",
      "iso2": "IS",
      "iso3": "ISL",
      "phoneCode": "354"
    },
    {
      "nameES": "ISLAS BERMUDAS",
      "nameEN": "Bermuda Islands",
      "iso2": "BM",
      "iso3": "BMU",
      "phoneCode": "1 441"
    },
    {
      "nameES": "ISLAS CAIMÁN",
      "nameEN": "Cayman Islands",
      "iso2": "KY",
      "iso3": "CYM",
      "phoneCode": "1 345"
    },
    {
      "nameES": "ISLAS COCOS (KEELING)",
      "nameEN": "Cocos (Keeling) Islands",
      "iso2": "CC",
      "iso3": "CCK",
      "phoneCode": "61"
    },
    {
      "nameES": "ISLAS COOK",
      "nameEN": "Cook Islands",
      "iso2": "CK",
      "iso3": "COK",
      "phoneCode": "682"
    },
    {
      "nameES": "ISLAS DE ÅLAND",
      "nameEN": "Åland Islands",
      "iso2": "AX",
      "iso3": "ALA",
      "phoneCode": "358"
    },
    {
      "nameES": "ISLAS FEROE",
      "nameEN": "Faroe Islands",
      "iso2": "FO",
      "iso3": "FRO",
      "phoneCode": "298"
    },
    {
      "nameES": "ISLAS GEORGIAS DEL SUR Y SANDWICH DEL SUR",
      "nameEN": "South Georgia and the South Sandwich Islands",
      "iso2": "GS",
      "iso3": "SGS",
      "phoneCode": "500"
    },
    {
      "nameES": "ISLAS HEARD Y MCDONALD",
      "nameEN": "Heard Island and McDonald Islands",
      "iso2": "HM",
      "iso3": "HMD",
      "phoneCode": ""
    },
    {
      "nameES": "ISLAS MALDIVAS",
      "nameEN": "Maldives",
      "iso2": "MV",
      "iso3": "MDV",
      "phoneCode": "960"
    },
    {
      "nameES": "ISLAS MALVINAS",
      "nameEN": "Falkland Islands (Malvinas)",
      "iso2": "FK",
      "iso3": "FLK",
      "phoneCode": "500"
    },
    {
      "nameES": "ISLAS MARIANAS DEL NORTE",
      "nameEN": "Northern Mariana Islands",
      "iso2": "MP",
      "iso3": "MNP",
      "phoneCode": "1 670"
    },
    {
      "nameES": "ISLAS MARSHALL",
      "nameEN": "Marshall Islands",
      "iso2": "MH",
      "iso3": "MHL",
      "phoneCode": "692"
    },
    {
      "nameES": "ISLAS PITCAIRN",
      "nameEN": "Pitcairn Islands",
      "iso2": "PN",
      "iso3": "PCN",
      "phoneCode": "870"
    },
    {
      "nameES": "ISLAS SALOMÓN",
      "nameEN": "Solomon Islands",
      "iso2": "SB",
      "iso3": "SLB",
      "phoneCode": "677"
    },
    {
      "nameES": "ISLAS TURCAS Y CAICOS",
      "nameEN": "Turks and Caicos Islands",
      "iso2": "TC",
      "iso3": "TCA",
      "phoneCode": "1 649"
    },
    {
      "nameES": "ISLAS ULTRAMARINAS MENORES DE ESTADOS UNIDOS",
      "nameEN": "United States Minor Outlying Islands",
      "iso2": "UM",
      "iso3": "UMI",
      "phoneCode": "246"
    },
    {
      "nameES": "ISLAS VÍRGENES BRITÁNICAS",
      "nameEN": "Virgin Islands",
      "iso2": "VG",
      "iso3": "VGB",
      "phoneCode": "1 284"
    },
    {
      "nameES": "ISLAS VÍRGENES DE LOS ESTADOS UNIDOS",
      "nameEN": "United States Virgin Islands",
      "iso2": "VI",
      "iso3": "VIR",
      "phoneCode": "1 340"
    },
    {
      "nameES": "ISRAEL",
      "nameEN": "Israel",
      "iso2": "IL",
      "iso3": "ISR",
      "phoneCode": "972"
    },
    {
      "nameES": "ITALIA",
      "nameEN": "Italy",
      "iso2": "IT",
      "iso3": "ITA",
      "phoneCode": "39"
    },
    {
      "nameES": "JAMAICA",
      "nameEN": "Jamaica",
      "iso2": "JM",
      "iso3": "JAM",
      "phoneCode": "1 876"
    },
    {
      "nameES": "JAPÓN",
      "nameEN": "Japan",
      "iso2": "JP",
      "iso3": "JPN",
      "phoneCode": "81"
    },
    {
      "nameES": "JERSEY",
      "nameEN": "Jersey",
      "iso2": "JE",
      "iso3": "JEY",
      "phoneCode": "44"
    },
    {
      "nameES": "JORDANIA",
      "nameEN": "Jordan",
      "iso2": "JO",
      "iso3": "JOR",
      "phoneCode": "962"
    },
    {
      "nameES": "KAZAJISTÁN",
      "nameEN": "Kazakhstan",
      "iso2": "KZ",
      "iso3": "KAZ",
      "phoneCode": "7"
    },
    {
      "nameES": "KENIA",
      "nameEN": "Kenya",
      "iso2": "KE",
      "iso3": "KEN",
      "phoneCode": "254"
    },
    {
      "nameES": "KIRGUISTÁN",
      "nameEN": "Kyrgyzstan",
      "iso2": "KG",
      "iso3": "KGZ",
      "phoneCode": "996"
    },
    {
      "nameES": "KIRIBATI",
      "nameEN": "Kiribati",
      "iso2": "KI",
      "iso3": "KIR",
      "phoneCode": "686"
    },
    {
      "nameES": "KUWAIT",
      "nameEN": "Kuwait",
      "iso2": "KW",
      "iso3": "KWT",
      "phoneCode": "965"
    },
    {
      "nameES": "LÍBANO",
      "nameEN": "Lebanon",
      "iso2": "LB",
      "iso3": "LBN",
      "phoneCode": "961"
    },
    {
      "nameES": "LAOS",
      "nameEN": "Laos",
      "iso2": "LA",
      "iso3": "LAO",
      "phoneCode": "856"
    },
    {
      "nameES": "LESOTO",
      "nameEN": "Lesotho",
      "iso2": "LS",
      "iso3": "LSO",
      "phoneCode": "266"
    },
    {
      "nameES": "LETONIA",
      "nameEN": "Latvia",
      "iso2": "LV",
      "iso3": "LVA",
      "phoneCode": "371"
    },
    {
      "nameES": "LIBERIA",
      "nameEN": "Liberia",
      "iso2": "LR",
      "iso3": "LBR",
      "phoneCode": "231"
    },
    {
      "nameES": "LIBIA",
      "nameEN": "Libya",
      "iso2": "LY",
      "iso3": "LBY",
      "phoneCode": "218"
    },
    {
      "nameES": "LIECHTENSTEIN",
      "nameEN": "Liechtenstein",
      "iso2": "LI",
      "iso3": "LIE",
      "phoneCode": "423"
    },
    {
      "nameES": "LITUANIA",
      "nameEN": "Lithuania",
      "iso2": "LT",
      "iso3": "LTU",
      "phoneCode": "370"
    },
    {
      "nameES": "LUXEMBURGO",
      "nameEN": "Luxembourg",
      "iso2": "LU",
      "iso3": "LUX",
      "phoneCode": "352"
    },
    {
      "nameES": "MÉXICO",
      "nameEN": "Mexico",
      "iso2": "MX",
      "iso3": "MEX",
      "phoneCode": "52"
    },
    {
      "nameES": "MÓNACO",
      "nameEN": "Monaco",
      "iso2": "MC",
      "iso3": "MCO",
      "phoneCode": "377"
    },
    {
      "nameES": "MACAO",
      "nameEN": "Macao",
      "iso2": "MO",
      "iso3": "MAC",
      "phoneCode": "853"
    },
    {
      "nameES": "MACEDÔNIA",
      "nameEN": "Macedonia",
      "iso2": "MK",
      "iso3": "MKD",
      "phoneCode": "389"
    },
    {
      "nameES": "MADAGASCAR",
      "nameEN": "Madagascar",
      "iso2": "MG",
      "iso3": "MDG",
      "phoneCode": "261"
    },
    {
      "nameES": "MALASIA",
      "nameEN": "Malaysia",
      "iso2": "MY",
      "iso3": "MYS",
      "phoneCode": "60"
    },
    {
      "nameES": "MALAWI",
      "nameEN": "Malawi",
      "iso2": "MW",
      "iso3": "MWI",
      "phoneCode": "265"
    },
    {
      "nameES": "MALI",
      "nameEN": "Mali",
      "iso2": "ML",
      "iso3": "MLI",
      "phoneCode": "223"
    },
    {
      "nameES": "MALTA",
      "nameEN": "Malta",
      "iso2": "MT",
      "iso3": "MLT",
      "phoneCode": "356"
    },
    {
      "nameES": "MARRUECOS",
      "nameEN": "Morocco",
      "iso2": "MA",
      "iso3": "MAR",
      "phoneCode": "212"
    },
    {
      "nameES": "MARTINICA",
      "nameEN": "Martinique",
      "iso2": "MQ",
      "iso3": "MTQ",
      "phoneCode": "596"
    },
    {
      "nameES": "MAURICIO",
      "nameEN": "Mauritius",
      "iso2": "MU",
      "iso3": "MUS",
      "phoneCode": "230"
    },
    {
      "nameES": "MAURITANIA",
      "nameEN": "Mauritania",
      "iso2": "MR",
      "iso3": "MRT",
      "phoneCode": "222"
    },
    {
      "nameES": "MAYOTTE",
      "nameEN": "Mayotte",
      "iso2": "YT",
      "iso3": "MYT",
      "phoneCode": "262"
    },
    {
      "nameES": "MICRONESIA",
      "nameEN": "Estados Federados de",
      "iso2": "FM",
      "iso3": "FSM",
      "phoneCode": "691"
    },
    {
      "nameES": "MOLDAVIA",
      "nameEN": "Moldova",
      "iso2": "MD",
      "iso3": "MDA",
      "phoneCode": "373"
    },
    {
      "nameES": "MONGOLIA",
      "nameEN": "Mongolia",
      "iso2": "MN",
      "iso3": "MNG",
      "phoneCode": "976"
    },
    {
      "nameES": "MONTENEGRO",
      "nameEN": "Montenegro",
      "iso2": "ME",
      "iso3": "MNE",
      "phoneCode": "382"
    },
    {
      "nameES": "MONTSERRAT",
      "nameEN": "Montserrat",
      "iso2": "MS",
      "iso3": "MSR",
      "phoneCode": "1 664"
    },
    {
      "nameES": "MOZAMBIQUE",
      "nameEN": "Mozambique",
      "iso2": "MZ",
      "iso3": "MOZ",
      "phoneCode": "258"
    },
    {
      "nameES": "NAMIBIA",
      "nameEN": "Namibia",
      "iso2": "NA",
      "iso3": "NAM",
      "phoneCode": "264"
    },
    {
      "nameES": "NAURU",
      "nameEN": "Nauru",
      "iso2": "NR",
      "iso3": "NRU",
      "phoneCode": "674"
    },
    {
      "nameES": "NEPAL",
      "nameEN": "Nepal",
      "iso2": "NP",
      "iso3": "NPL",
      "phoneCode": "977"
    },
    {
      "nameES": "NICARAGUA",
      "nameEN": "Nicaragua",
      "iso2": "NI",
      "iso3": "NIC",
      "phoneCode": "505"
    },
    {
      "nameES": "NIGER",
      "nameEN": "Niger",
      "iso2": "NE",
      "iso3": "NER",
      "phoneCode": "227"
    },
    {
      "nameES": "NIGERIA",
      "nameEN": "Nigeria",
      "iso2": "NG",
      "iso3": "NGA",
      "phoneCode": "234"
    },
    {
      "nameES": "NIUE",
      "nameEN": "Niue",
      "iso2": "NU",
      "iso3": "NIU",
      "phoneCode": "683"
    },
    {
      "nameES": "NORUEGA",
      "nameEN": "Norway",
      "iso2": "NO",
      "iso3": "NOR",
      "phoneCode": "47"
    },
    {
      "nameES": "NUEVA CALEDONIA",
      "nameEN": "New Caledonia",
      "iso2": "NC",
      "iso3": "NCL",
      "phoneCode": "687"
    },
    {
      "nameES": "NUEVA ZELANDA",
      "nameEN": "New Zealand",
      "iso2": "NZ",
      "iso3": "NZL",
      "phoneCode": "64"
    },
    {
      "nameES": "OMÁN",
      "nameEN": "Oman",
      "iso2": "OM",
      "iso3": "OMN",
      "phoneCode": "968"
    },
    {
      "nameES": "PAÍSES BAJOS",
      "nameEN": "Netherlands",
      "iso2": "NL",
      "iso3": "NLD",
      "phoneCode": "31"
    },
    {
      "nameES": "PAKISTÁN",
      "nameEN": "Pakistan",
      "iso2": "PK",
      "iso3": "PAK",
      "phoneCode": "92"
    },
    {
      "nameES": "PALAU",
      "nameEN": "Palau",
      "iso2": "PW",
      "iso3": "PLW",
      "phoneCode": "680"
    },
    {
      "nameES": "PALESTINA",
      "nameEN": "Palestine",
      "iso2": "PS",
      "iso3": "PSE",
      "phoneCode": "970"
    },
    {
      "nameES": "PANAMÁ",
      "nameEN": "Panama",
      "iso2": "PA",
      "iso3": "PAN",
      "phoneCode": "507"
    },
    {
      "nameES": "PAPÚA NUEVA GUINEA",
      "nameEN": "Papua New Guinea",
      "iso2": "PG",
      "iso3": "PNG",
      "phoneCode": "675"
    },
    {
      "nameES": "PARAGUAY",
      "nameEN": "Paraguay",
      "iso2": "PY",
      "iso3": "PRY",
      "phoneCode": "595"
    },
    {
      "nameES": "PERÚ",
      "nameEN": "Peru",
      "iso2": "PE",
      "iso3": "PER",
      "phoneCode": "51"
    },
    {
      "nameES": "POLINESIA FRANCESA",
      "nameEN": "French Polynesia",
      "iso2": "PF",
      "iso3": "PYF",
      "phoneCode": "689"
    },
    {
      "nameES": "POLONIA",
      "nameEN": "Poland",
      "iso2": "PL",
      "iso3": "POL",
      "phoneCode": "48"
    },
    {
      "nameES": "PORTUGAL",
      "nameEN": "Portugal",
      "iso2": "PT",
      "iso3": "PRT",
      "phoneCode": "351"
    },
    {
      "nameES": "PUERTO RICO",
      "nameEN": "Puerto Rico",
      "iso2": "PR",
      "iso3": "PRI",
      "phoneCode": "1"
    },
    {
      "nameES": "QATAR",
      "nameEN": "Qatar",
      "iso2": "QA",
      "iso3": "QAT",
      "phoneCode": "974"
    },
    {
      "nameES": "REINO UNIDO",
      "nameEN": "United Kingdom",
      "iso2": "GB",
      "iso3": "GBR",
      "phoneCode": "44"
    },
    {
      "nameES": "REPÚBLICA CENTROAFRICANA",
      "nameEN": "Central African Republic",
      "iso2": "CF",
      "iso3": "CAF",
      "phoneCode": "236"
    },
    {
      "nameES": "REPÚBLICA CHECA",
      "nameEN": "Czech Republic",
      "iso2": "CZ",
      "iso3": "CZE",
      "phoneCode": "420"
    },
    {
      "nameES": "REPÚBLICA DOMINICANA",
      "nameEN": "Dominican Republic",
      "iso2": "DO",
      "iso3": "DOM",
      "phoneCode": "1 809"
    },
    {
      "nameES": "REPÚBLICA DE SUDÁN DEL SUR",
      "nameEN": "South Sudan",
      "iso2": "SS",
      "iso3": "SSD",
      "phoneCode": "211"
    },
    {
      "nameES": "REUNIÓN",
      "nameEN": "Réunion",
      "iso2": "RE",
      "iso3": "REU",
      "phoneCode": "262"
    },
    {
      "nameES": "RUANDA",
      "nameEN": "Rwanda",
      "iso2": "RW",
      "iso3": "RWA",
      "phoneCode": "250"
    },
    {
      "nameES": "RUMANÍA",
      "nameEN": "Romania",
      "iso2": "RO",
      "iso3": "ROU",
      "phoneCode": "40"
    },
    {
      "nameES": "RUSIA",
      "nameEN": "Russia",
      "iso2": "RU",
      "iso3": "RUS",
      "phoneCode": "7"
    },
    {
      "nameES": "SAHARA OCCIDENTAL",
      "nameEN": "Western Sahara",
      "iso2": "EH",
      "iso3": "ESH",
      "phoneCode": "212"
    },
    {
      "nameES": "SAMOA",
      "nameEN": "Samoa",
      "iso2": "WS",
      "iso3": "WSM",
      "phoneCode": "685"
    },
    {
      "nameES": "SAMOA AMERICANA",
      "nameEN": "American Samoa",
      "iso2": "AS",
      "iso3": "ASM",
      "phoneCode": "1 684"
    },
    {
      "nameES": "SAN BARTOLOMÉ",
      "nameEN": "Saint Barthélemy",
      "iso2": "BL",
      "iso3": "BLM",
      "phoneCode": "590"
    },
    {
      "nameES": "SAN CRISTÓBAL Y NIEVES",
      "nameEN": "Saint Kitts and Nevis",
      "iso2": "KN",
      "iso3": "KNA",
      "phoneCode": "1 869"
    },
    {
      "nameES": "SAN MARINO",
      "nameEN": "San Marino",
      "iso2": "SM",
      "iso3": "SMR",
      "phoneCode": "378"
    },
    {
      "nameES": "SAN MARTÍN (FRANCIA)",
      "nameEN": "Saint Martin (French part)",
      "iso2": "MF",
      "iso3": "MAF",
      "phoneCode": "1 599"
    },
    {
      "nameES": "SAN PEDRO Y MIQUELÓN",
      "nameEN": "Saint Pierre and Miquelon",
      "iso2": "PM",
      "iso3": "SPM",
      "phoneCode": "508"
    },
    {
      "nameES": "SAN VICENTE Y LAS GRANADINAS",
      "nameEN": "Saint Vincent and the Grenadines",
      "iso2": "VC",
      "iso3": "VCT",
      "phoneCode": "1 784"
    },
    {
      "nameES": "SANTA ELENA",
      "nameEN": "Ascensión y Tristán de Acuña",
      "iso2": "SH",
      "iso3": "SHN",
      "phoneCode": "290"
    },
    {
      "nameES": "SANTA LUCÍA",
      "nameEN": "Saint Lucia",
      "iso2": "LC",
      "iso3": "LCA",
      "phoneCode": "1 758"
    },
    {
      "nameES": "SANTO TOMÉ Y PRÍNCIPE",
      "nameEN": "Sao Tome and Principe",
      "iso2": "ST",
      "iso3": "STP",
      "phoneCode": "239"
    },
    {
      "nameES": "SENEGAL",
      "nameEN": "Senegal",
      "iso2": "SN",
      "iso3": "SEN",
      "phoneCode": "221"
    },
    {
      "nameES": "SERBIA",
      "nameEN": "Serbia",
      "iso2": "RS",
      "iso3": "SRB",
      "phoneCode": "381"
    },
    {
      "nameES": "SEYCHELLES",
      "nameEN": "Seychelles",
      "iso2": "SC",
      "iso3": "SYC",
      "phoneCode": "248"
    },
    {
      "nameES": "SIERRA LEONA",
      "nameEN": "Sierra Leone",
      "iso2": "SL",
      "iso3": "SLE",
      "phoneCode": "232"
    },
    {
      "nameES": "SINGAPUR",
      "nameEN": "Singapore",
      "iso2": "SG",
      "iso3": "SGP",
      "phoneCode": "65"
    },
    {
      "nameES": "SINT MAARTEN",
      "nameEN": "Sint Maarten",
      "iso2": "SX",
      "iso3": "SMX",
      "phoneCode": "1 721"
    },
    {
      "nameES": "SIRIA",
      "nameEN": "Syria",
      "iso2": "SY",
      "iso3": "SYR",
      "phoneCode": "963"
    },
    {
      "nameES": "SOMALIA",
      "nameEN": "Somalia",
      "iso2": "SO",
      "iso3": "SOM",
      "phoneCode": "252"
    },
    {
      "nameES": "SRI LANKA",
      "nameEN": "Sri Lanka",
      "iso2": "LK",
      "iso3": "LKA",
      "phoneCode": "94"
    },
    {
      "nameES": "SUDÁFRICA",
      "nameEN": "South Africa",
      "iso2": "ZA",
      "iso3": "ZAF",
      "phoneCode": "27"
    },
    {
      "nameES": "SUDÁN",
      "nameEN": "Sudan",
      "iso2": "SD",
      "iso3": "SDN",
      "phoneCode": "249"
    },
    {
      "nameES": "SUECIA",
      "nameEN": "Sweden",
      "iso2": "SE",
      "iso3": "SWE",
      "phoneCode": "46"
    },
    {
      "nameES": "SUIZA",
      "nameEN": "Switzerland",
      "iso2": "CH",
      "iso3": "CHE",
      "phoneCode": "41"
    },
    {
      "nameES": "SURINÁM",
      "nameEN": "Suriname",
      "iso2": "SR",
      "iso3": "SUR",
      "phoneCode": "597"
    },
    {
      "nameES": "SVALBARD Y JAN MAYEN",
      "nameEN": "Svalbard and Jan Mayen",
      "iso2": "SJ",
      "iso3": "SJM",
      "phoneCode": "47"
    },
    {
      "nameES": "SWAZILANDIA",
      "nameEN": "Swaziland",
      "iso2": "SZ",
      "iso3": "SWZ",
      "phoneCode": "268"
    },
    {
      "nameES": "TAYIKISTÁN",
      "nameEN": "Tajikistan",
      "iso2": "TJ",
      "iso3": "TJK",
      "phoneCode": "992"
    },
    {
      "nameES": "TAILANDIA",
      "nameEN": "Thailand",
      "iso2": "TH",
      "iso3": "THA",
      "phoneCode": "66"
    },
    {
      "nameES": "TAIWÁN",
      "nameEN": "Taiwan",
      "iso2": "TW",
      "iso3": "TWN",
      "phoneCode": "886"
    },
    {
      "nameES": "TANZANIA",
      "nameEN": "Tanzania",
      "iso2": "TZ",
      "iso3": "TZA",
      "phoneCode": "255"
    },
    {
      "nameES": "TERRITORIO BRITÁNICO DEL OCÉANO ÍNDICO",
      "nameEN": "British Indian Ocean Territory",
      "iso2": "IO",
      "iso3": "IOT",
      "phoneCode": "246"
    },
    {
      "nameES": "TERRITORIOS AUSTRALES Y ANTÁRTICAS FRANCESES",
      "nameEN": "French Southern Territories",
      "iso2": "TF",
      "iso3": "ATF",
      "phoneCode": ""
    },
    {
      "nameES": "TIMOR ORIENTAL",
      "nameEN": "East Timor",
      "iso2": "TL",
      "iso3": "TLS",
      "phoneCode": "670"
    },
    {
      "nameES": "TOGO",
      "nameEN": "Togo",
      "iso2": "TG",
      "iso3": "TGO",
      "phoneCode": "228"
    },
    {
      "nameES": "TOKELAU",
      "nameEN": "Tokelau",
      "iso2": "TK",
      "iso3": "TKL",
      "phoneCode": "690"
    },
    {
      "nameES": "TONGA",
      "nameEN": "Tonga",
      "iso2": "TO",
      "iso3": "TON",
      "phoneCode": "676"
    },
    {
      "nameES": "TRINIDAD Y TOBAGO",
      "nameEN": "Trinidad and Tobago",
      "iso2": "TT",
      "iso3": "TTO",
      "phoneCode": "1 868"
    },
    {
      "nameES": "TUNEZ",
      "nameEN": "Tunisia",
      "iso2": "TN",
      "iso3": "TUN",
      "phoneCode": "216"
    },
    {
      "nameES": "TURKMENISTÁN",
      "nameEN": "Turkmenistan",
      "iso2": "TM",
      "iso3": "TKM",
      "phoneCode": "993"
    },
    {
      "nameES": "TURQUÍA",
      "nameEN": "Turkey",
      "iso2": "TR",
      "iso3": "TUR",
      "phoneCode": "90"
    },
    {
      "nameES": "TUVALU",
      "nameEN": "Tuvalu",
      "iso2": "TV",
      "iso3": "TUV",
      "phoneCode": "688"
    },
    {
      "nameES": "UCRANIA",
      "nameEN": "Ukraine",
      "iso2": "UA",
      "iso3": "UKR",
      "phoneCode": "380"
    },
    {
      "nameES": "UGANDA",
      "nameEN": "Uganda",
      "iso2": "UG",
      "iso3": "UGA",
      "phoneCode": "256"
    },
    {
      "nameES": "URUGUAY",
      "nameEN": "Uruguay",
      "iso2": "UY",
      "iso3": "URY",
      "phoneCode": "598"
    },
    {
      "nameES": "UZBEKISTÁN",
      "nameEN": "Uzbekistan",
      "iso2": "UZ",
      "iso3": "UZB",
      "phoneCode": "998"
    },
    {
      "nameES": "VANUATU",
      "nameEN": "Vanuatu",
      "iso2": "VU",
      "iso3": "VUT",
      "phoneCode": "678"
    },
    {
      "nameES": "VENEZUELA",
      "nameEN": "Venezuela",
      "iso2": "VE",
      "iso3": "VEN",
      "phoneCode": "58"
    },
    {
      "nameES": "VIETNAM",
      "nameEN": "Vietnam",
      "iso2": "VN",
      "iso3": "VNM",
      "phoneCode": "84"
    },
    {
      "nameES": "WALLIS Y FUTUNA",
      "nameEN": "Wallis and Futuna",
      "iso2": "WF",
      "iso3": "WLF",
      "phoneCode": "681"
    },
    {
      "nameES": "YEMEN",
      "nameEN": "Yemen",
      "iso2": "YE",
      "iso3": "YEM",
      "phoneCode": "967"
    },
    {
      "nameES": "YIBUTI",
      "nameEN": "Djibouti",
      "iso2": "DJ",
      "iso3": "DJI",
      "phoneCode": "253"
    },
    {
      "nameES": "ZAMBIA",
      "nameEN": "Zambia",
      "iso2": "ZM",
      "iso3": "ZMB",
      "phoneCode": "260"
    },
    {
      "nameES": "ZIMBABUE",
      "nameEN": "Zimbabwe",
      "iso2": "ZW",
      "iso3": "ZWE",
      "phoneCode": "263"
    }
  ];

// Formatted for PrimeNG dropdowns
export const COUNTRIES: any = COUNTRIES_RAW.map(country => ({
  label: country.nameES,
  value: country.nameES,
  iso2: country.iso2
}));

export const COUNTRY_CODES: any = COUNTRIES_RAW.map(country => ({
  label: country.iso2,
  value: country.iso2
}));

// Combined selector for addresses: displays country with iso3, stores iso3
export const COUNTRIES_WITH_PHONE: any = COUNTRIES_RAW.map(country => ({
  label: `${country.iso3} - ${country.nameES} `,
  value: country.iso3,
  iso2: country.iso2,
  iso3: country.iso3,
  nameES: country.nameES,
  phoneCode: country.phoneCode
}));
